import React from 'react';

const TableRow = ({ row, selectedEvent, onSelectEvent, children }) => (
    <div 
        className={`risk-events-tab-table-row ${selectedEvent?.id === row?.id ? 'selected' : ''}`}
        onClick={() => onSelectEvent(row)}
    >
        {children}
    </div>
);

export default React.memo(TableRow);
